import React, {Component} from 'react'

import {
  withRouter
} from 'react-router-dom';

import Site,{withSite,SiteModifier_} from '../../utils/Site'

import PageTitle from '../../components/PageTitle';
import SetTemplate from '../../components/SetTemplate';
import withData from '../../utils/withData';

// Templates
import Default from '../../templates/Default';
import Compare from '../../templates/Compare';
import Home from '../../templates/Home';
import Grid from '../../templates/Grid';
import Map from '../../templates/Map';
import Location from '../../templates/Location';
import About from '../../templates/About';
import News from '../../templates/News';
import Article from '../../templates/Article';
import Events from '../../templates/Events';
import Event from '../../templates/Event';
import PlanMyDay from '../../templates/PlanMyDay';
import NoDollar from '../../templates/NoDollar';
import NotFound from '../../templates/Error';
import Thanks from '../../templates/Thanks';
import Signup from '../../templates/Signup';
import Promotion from '../../templates/Promotion';

const Templates = {

  'default' : Default,
  'planMyDay' : PlanMyDay,
  'compare' : Compare,
  'home' : Home,
  'grid' : Grid,
  'news' : News,
  'article' : Article,
  'events' : Events,
  'event' : Event,
  'map' : Map,
  'location' : Location,
  'no-dollar' : NoDollar,
  'about' : About,
  'error': NotFound,
  'signUpThanks': Thanks,
  'signUp': Signup,
  'promotion': Promotion

}

class Template extends Component {

  
  render () {



      const entries = this.props.entries;

      if(!entries) return null;

      let {location} = this.props;

      //console.log(location)


      const matches = (entries.filter((i) => {
        return (i.uri == location.pathname)
      }) )

      //console.log(matches)


      const found = matches.length > 0;
      let entry;
      if(found){

        entry = matches[0];

      }


      let template;

      if(found){

        if(Templates.hasOwnProperty(entry.template)) {
          template = entry.template;
        }else if(Templates.hasOwnProperty(entry.slug)){
          template = entry.slug;
        }else if(Templates.hasOwnProperty(entry.type)){
          template = entry.type;
        }else{
          template = 'default';
        }

      }else{

          template = 'error';

      }

      //this.props.datastore.set('template',template)
      this.template = template

    const Output = Templates[template];

    return (
          [
          <PageTitle entry={entry} />,
          <SetTemplate template={template}>
          <Output entry={entry} />
          </SetTemplate>
          ]

    )
  }
}

export default withData(withRouter(Template))



// WEBPACK FOOTER //
// ./src/js/components/Template/Template.jsx